(() => {
  'use strict';
  const plain = value => typeof value === 'string' ? value.replace(/&(amp|lt|gt|quot|apos|#39|#x27);/g, entity => ({'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&apos;':"'",'&#39;':"'",'&#x27;':"'"}[entity])) : Array.isArray(value) ? value.map(plain) : value && typeof value === 'object' ? Object.fromEntries(Object.entries(value).map(([key, item]) => [key, plain(item)])) : value;
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const int = (v, min = 0, max = 250) => /^\d+$/.test(String(v)) && Number.isSafeInteger(Number(v)) && Number(v) >= min && Number(v) <= max;
  const format = (cents, currency = 'EUR') => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  const fileOK = f => !!f && f.size > 0 && f.size <= 10485760 && /\.(png|jpe?g|pdf)$/i.test(f.name) && (!f.type || ['image/png', 'image/jpeg', 'application/pdf'].includes(f.type));
  function recommend(a, catalog) {
    const available = new Set(['black', 'navy', 'white', 'blue', 'grey', 'any']);
    const direct = a.protection === 'normal' && a.scope === 'shirts' && a.tier === 'basic' && a.colors.length > 0 && a.colors.every(c => available.has(c)) && a.people <= 20;
    const category = catalog?.categories?.find(c => c.id === a.scope);
    const fallback = a.scope === 'shirts' ? ({basic:'Santino Jaro',comfort:'Santino Jacob',premium:'Blåkläder T-shirt Pro 3535-1063'}[a.tier] || null) : null;
    const model = a.protection === 'normal' ? (category?.models?.[a.tier]?.model || fallback) : null;
    const footwear = !!category?.footwear || ['low_shoes','high_shoes','boots'].includes(a.scope);
    return { direct, model, footwear, pack: a.people > 10 ? 20 : 10, protection: a.protection !== 'normal', layer: ['upper','full'].includes(a.scope), trousers: false, jacket: a.environment !== 'indoor' && ['upper','full'].includes(a.scope) };
  }
  function totals(config, count, print) {
    const net = config.net[String(count)];
    if (!Number.isSafeInteger(net) || !Object.hasOwn(config.print, print)) return null;
    const printing = config.print[print] * count;
    return { clothing: net, printing, net: net + printing };
  }
  window.WorkwearSelect = Object.freeze({ recommend, totals, fileOK });
  if (!customElements.get('ws-assortment')) customElements.define('ws-assortment', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return; this.initialized = true;
      const picker = this.querySelector('[data-assortment-category]');
      const params = new URLSearchParams(location.search);
      const initial = [...picker.options].find(o => o.value === params.get('category'));
      if (initial) picker.value = initial.value;
      const update = () => this.querySelectorAll('[data-assortment-panel]').forEach(el => { el.hidden = el.dataset.assortmentPanel !== picker.value; });
      picker.addEventListener('change', update); update();
    }
  });
  if (!customElements.get('ws-select-guide')) customElements.define('ws-select-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = plain(JSON.parse(this.querySelector('[data-guide-labels]').textContent));
      this.catalog = JSON.parse(this.querySelector('[data-guide-catalog]').textContent);
      this.form = this.querySelector('[data-guide-form]');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.index = 0;
      this.form.addEventListener('submit', e => { e.preventDefault(); this.next(); });
      this.querySelector('[data-guide-back]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-guide-restart]').addEventListener('click', () => this.restart());
      this.form.addEventListener('change', e => {
        if (e.target.name === 'colors' && e.target.checked) {
          this.form.querySelectorAll('[name=colors]').forEach(c => { if (c !== e.target && (e.target.value === 'any' || c.value === 'any')) c.checked = false; });
        }
        this.querySelector('[data-guide-error]').textContent = '';
      });
      document.querySelectorAll('[data-guide-tier]').forEach(link => link.addEventListener('click', () => {
        const tier = this.form.querySelector(`[name=tier][value="${link.dataset.guideTier}"]`);
        if (tier) tier.checked = true;
        const scope = [...this.form.querySelectorAll('[name=scope]')].find(x => x.value === link.dataset.guideScope);
        if (scope) scope.checked = true;
        if (this.querySelector('[data-guide-body]').hidden) this.restart();
      }));
      const params = new URLSearchParams(location.search);
      if (params.has('tier')) {
        const tier = [...this.form.querySelectorAll('[name=tier]')].find(x => x.value === params.get('tier'));
        if (tier) tier.checked = true;
      }
      const scope = [...this.form.querySelectorAll('[name=scope]')].find(x => x.value === params.get('scope'));
      if (scope) scope.checked = true;
      this.show(0, false);
      if (this.querySelector('[data-form-success],.errors')) {
        this.querySelector('[data-request-panel]').hidden = false;
        this.querySelector('[data-guide-body]').hidden = true;
      }
    }
    value(name) { return this.form.querySelector(`[name="${name}"]:checked`)?.value || ''; }
    answers() {
      return { job: this.value('job'), protection: this.value('protection'), environment: this.value('environment'), colors: [...this.form.querySelectorAll('[name=colors]:checked')].map(x => x.value), scope: this.value('scope'), people: Number(this.form.elements.people.value), tier: this.value('tier'), logo: this.value('logo') };
    }
    show(index, focus = true) {
      this.index = Math.max(0, Math.min(6, index));
      this.steps.forEach((step, i) => step.hidden = i !== this.index);
      const footwear = ['low_shoes','high_shoes','boots'].includes(this.value('scope'));
      const stepCount = footwear ? 6 : 7;
      this.querySelector('[data-step-total]').textContent = String(stepCount);
      this.querySelector('[data-step-number]').textContent = String(this.index + 1);
      this.querySelector('[data-guide-progress]').style.width = `${(this.index + 1) / stepCount * 100}%`;
      this.querySelector('[data-guide-back]').hidden = this.index === 0;
      this.querySelector('[data-guide-next]').textContent = ((this.index === 6 || (footwear && this.index === 5)) ? this.labels.view_result : this.labels.next) + ' →';
      this.querySelector('[data-guide-error]').textContent = '';
      if (focus) this.steps[this.index].querySelector('legend').focus({ preventScroll: true });
    }
    validStep() {
      const a = this.answers();
      return [() => !!a.job && !!a.protection, () => !!a.environment, () => a.colors.length > 0, () => !!a.scope, () => int(this.form.elements.people.value, 1, 250), () => !!a.tier, () => !!a.logo][this.index]();
    }
    next() {
      if (!this.validStep()) {
        this.querySelector('[data-guide-error]').textContent = this.index === 4 ? this.labels.people_error : this.labels.fill_error;
        return;
      }
      if (this.index === 5 && ['low_shoes','high_shoes','boots'].includes(this.value('scope'))) { this.form.querySelector('[name=logo][value=none]').checked = true; this.result(); }
      else if (this.index < 6) this.show(this.index + 1); else this.result();
    }
    restart() {
      this.querySelector('[data-guide-body]').hidden = false;
      this.querySelector('[data-guide-result]').hidden = true;
      this.querySelector('[data-request-panel]').hidden = true;
      this.show(0);
    }
    result() {
      const a = this.answers(), r = recommend(a, this.catalog), l = this.labels;
      const rows = [
        [l.fields.job, l.jobs[a.job]], [l.fields.protection, l.protection[a.protection]],
        [l.fields.environment, l.environment[a.environment]], [l.fields.colors, a.colors.map(c => l.colors[c]).join(', ')],
        [l.fields.scope, l.scope[a.scope]], [l.fields.people, String(a.people)],
        [l.fields.tier, l.tiers[a.tier]], [l.fields.logo, l.logos[a.logo]]
      ];
      if (r.model) rows.push([l.fields.model, r.model]);
      this.querySelectorAll('[data-tier-model]').forEach(el => { el.hidden = !r.model || a.scope !== 'shirts' || el.dataset.tierModel !== a.tier; });
      const summary = this.querySelector('[data-answer-summary]'); summary.replaceChildren();
      rows.forEach(([key, value]) => { const div = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = key; dd.textContent = value; div.append(dt, dd); summary.append(div); });
      this.querySelector('[data-guide-body]').hidden = true;
      this.querySelector('[data-guide-result]').hidden = false;
      this.querySelector('[data-result-match]').hidden = !r.direct;
      this.querySelector('[data-match-reason]').hidden = !r.direct;
      this.querySelector('[data-result-custom]').hidden = r.direct;
      this.querySelector('[data-custom-reason]').hidden = r.direct;
      this.querySelector('[data-protection-warning]').hidden = !r.protection;
      this.querySelector('[data-footwear-note]').hidden = !r.footwear;
      this.querySelector('[data-package-proposal]').hidden = !['upper','full'].includes(a.scope);
      this.querySelector('[data-proposal-layer]').hidden = !r.layer;
      this.querySelector('[data-proposal-trousers]').hidden = !r.trousers;
      this.querySelector('[data-proposal-jacket]').hidden = !r.jacket;
      const link = this.querySelector('[data-configure]'); link.hidden = !r.direct;
      const url = new URL(this.dataset.packUrl, location.origin);
      url.searchParams.set('pack', r.pack); url.searchParams.set('print', a.logo); url.searchParams.set('colors', a.colors.join(','));
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      link.href = url.href;
      this.querySelector('[data-request-summary]').value = 'Workwear Select\n\n' + rows.map(([key, value]) => `${key}: ${value}`).join('\n');
      this.querySelector('[data-request-panel]').hidden = r.direct;
      this.querySelector('[data-guide-result]').focus({ preventScroll: true });
    }
  });
  if (!customElements.get('ws-package-order')) customElements.define('ws-package-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-package-config]').textContent);
      this.config.labels = plain(this.config.labels);
      this.form = this.querySelector('[data-pack-form]');
      if (!this.form) return;
      this.fields = [...this.querySelectorAll('[data-size-qty]')];
      this.button = this.querySelector('[data-add-pack]');
      this.error = this.querySelector('[data-pack-error]');
      this.busy = false; this.uncertain = false;
      this.form.addEventListener('input', () => this.refresh());
      this.form.addEventListener('change', () => this.refresh());
      this.form.addEventListener('submit', e => { e.preventDefault(); this.submit(); });
      this.querySelector('[data-clear]').addEventListener('click', () => { this.fields.forEach(f => f.value = '0'); this.refresh(); });
      this.querySelector('[data-color-filter]').addEventListener('change', e => { this.querySelectorAll('[data-size-color]').forEach(row => row.hidden = !!e.target.value && row.dataset.sizeColor !== e.target.value); });
      const params = new URLSearchParams(location.search);
      for (const [name, param] of [['ws_pack', 'pack'], ['ws_print', 'print']]) {
        const input = [...this.form.querySelectorAll(`[name=${name}]`)].find(f => f.value === params.get(param));
        if (input) input.checked = true;
      }
      const colors = (params.get('colors') || '').split(',');
      const filter = this.querySelector('[data-color-filter]');
      const option = [...filter.options].find(o => o.value && o.value.toLowerCase() === colors[0]);
      if (option && colors.length === 1) { filter.value = option.value; filter.dispatchEvent(new Event('change')); }
      this.refresh();
    }
    count() { return Number(this.form.querySelector('[name=ws_pack]:checked')?.value) || 10; }
    print() { return this.form.querySelector('[name=ws_print]:checked')?.value || 'none'; }
    selected() { return this.fields.filter(f => int(f.value, 1, this.count())); }
    variant() { return this.config.variants.find(v => v.option1 === String(this.count()) && v.option2 === this.print()); }
    selectionValid() { return this.fields.every(f => int(f.value, 0, this.count())) && this.selected().reduce((n, f) => n + Number(f.value), 0) === this.count(); }
    refresh() {
      const count = this.count(), print = this.print(), t = totals(this.config, count, print), variant = this.variant();
      const chosen = this.fields.reduce((n, f) => n + (int(f.value, 0, 250) ? Number(f.value) : 0), 0);
      this.fields.forEach(f => f.max = String(count));
      this.querySelector('[data-selection-count]').textContent = `${chosen} / ${count} ${this.config.labels.selected}`;
      this.querySelector('[data-size-progress]').style.width = `${Math.min(100, chosen / count * 100)}%`;
      this.querySelector('[data-logo-upload]').hidden = print === 'none';
      const file = this.querySelector('[data-logo-file]'); file.disabled = print === 'none'; file.required = print !== 'none';
      this.querySelector('[data-logo-notes]').disabled = print === 'none';
      this.querySelector('[data-clothing-total]').textContent = format(t.clothing);
      this.querySelector('[data-print-total]').textContent = format(t.printing);
      this.querySelector('[data-net-total]').textContent = format(t.net);
      this.querySelector('[data-gross-total]').textContent = format(Math.round(t.net * 1.21));
      this.querySelector('[data-pack-id]').value = variant?.id || '';
      this.querySelector('[data-pack-property]').value = `${count} T-shirts`;
      this.querySelector('[data-size-property]').value = this.selected().map(f => `${f.dataset.color} / ${f.dataset.size}: ${f.value}`).join('; ');
      this.querySelector('[data-logo-property]').value = this.config.labels.logos[print];
      const ready = variant?.available && Number(variant.price) > 0 && this.dataset.currency === this.dataset.baseCurrency && this.dataset.baseCurrency === 'EUR';
      this.button.disabled = this.busy || this.uncertain || !ready || !this.selectionValid() || (print !== 'none' && !fileOK(file.files[0]));
      this.button.textContent = this.busy ? this.config.labels.adding : this.config.labels.add + ' ↗';
      if (!ready) this.error.textContent = this.config.labels.pending;
      else if (!this.uncertain && !this.busy) this.error.textContent = (file.files.length && print !== 'none' && !fileOK(file.files[0])) ? this.config.labels.file_error : '';
    }
    async submit() {
      if (this.busy || this.uncertain) return;
      const variant = this.variant();
      if (!this.selectionValid()) { this.error.textContent = this.config.labels.selection_error; return; }
      if (!variant?.available || Number(variant.price) <= 0) { this.error.textContent = this.config.labels.pending; return; }
      const file = this.querySelector('[data-logo-file]');
      if (this.print() !== 'none' && !fileOK(file.files[0])) { this.error.textContent = this.config.labels.file_error; file.focus(); return; }
      this.busy = true; this.error.textContent = ''; this.refresh();
      const data = new FormData(this.form); data.delete('ws_pack'); data.delete('ws_print');
      if (this.print() === 'none') { data.delete('properties[Logobestand]'); data.delete('properties[Logo-opmerking]'); }
      let confirmedFailure = false;
      try {
        const response = await fetch(root() + 'cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) { confirmedFailure = true; throw new Error('Rejected'); }
        const result = await response.json();
        if (String(result.variant_id || result.id) !== String(variant.id) || result.quantity !== 1) throw new Error('Unconfirmed');
        location.assign(root() + 'cart');
      } catch {
        this.uncertain = !confirmedFailure;
        this.error.textContent = this.config.labels.add_error;
        this.querySelector('[data-check-cart]').hidden = false;
      } finally { this.busy = false; this.refresh(); }
    }
  });
})();
